module.exports = __webpack_public_path__ + "img/vip_icon1@2x.7ef3fb8d.png";